let domain
let appHttpUrl
// 开发环境
if (process.env.NODE_ENV === 'development') {
	domain = "http://stadium.dev.huaxiweiying.com/";
	appHttpUrl = "http://app.dev.huaxiweiying.com/";
} else {
	// 测试环境
	if (process.env.type === 'test') {
		domain = "http://stadium.dev.huaxiweiying.com/";
		appHttpUrl = "http://app.dev.huaxiweiying.com/";
	} else {
		// 正式环境
		domain = "http://stadium.huaxiweiying.com/";
		appHttpUrl = "http://app.huaxiweiying.com/";
	}
} 
module.exports = {
	httpUrl: domain,
	appHttpUrl:appHttpUrl
}



// WEBPACK FOOTER //
// ./src/config/URL.js